// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateDiamondSearchProductEnquiryExistingCustomerDocument = `
    mutation createDiamondSearchProductEnquiryExistingCustomer($input: EnquiryDiamondSearchProduct!) {
  createEnquiryDiamondSearchProductExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useCreateDiamondSearchProductEnquiryExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateDiamondSearchProductEnquiryExistingCustomerMutation, SchemaTypes.CreateDiamondSearchProductEnquiryExistingCustomerMutationVariables>(CreateDiamondSearchProductEnquiryExistingCustomerDocument);
};